var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcAddPropertyPaymentMaster(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 39.083,
    height: 23.344,
    viewBox: "0 0 39.083 23.344",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ic_add_property_payment_master",
    transform: "translate(16654.009 -7169.525)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_17",
    "data-name": "Path 17",
    d: "M588.062,666.066a11.428,11.428,0,1,1-.87-4.374A11.428,11.428,0,0,1,588.062,666.066Z",
    transform: "translate(-17204.326 6514.985)",
    fill: "#ffc107"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18",
    "data-name": "Path 18",
    d: "M565.179,672.922a11.393,11.393,0,0,1-1.348-2.287h6.085a11.344,11.344,0,0,0,.727-2.285h-7.536a11.323,11.323,0,0,1-.233-2.285h8a11.654,11.654,0,0,0-.228-2.285H563.1a11.4,11.4,0,0,1,.728-2.287h6.085a11.392,11.392,0,0,0-1.341-2.285h-3.4a11.481,11.481,0,0,1,1.692-1.825,11.431,11.431,0,1,0,1.7,15.54Z",
    transform: "translate(-17202 6514.985)",
    fill: "#ff3d00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19",
    "data-name": "Path 19",
    d: "M589.385,666.162a11.535,11.535,0,1,1-.85-4.447,11.535,11.535,0,0,1,.85,4.447Z",
    transform: "translate(-17204.479 6515)",
    fill: "#ffb600"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20",
    "data-name": "Path 20",
    d: "M577.845,654.636a11.624,11.624,0,1,1-11.54,11.541",
    transform: "translate(-17204.479 6514.985)",
    fill: "#f7981d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21",
    "data-name": "Path 21",
    d: "M579.65,654.636a11.54,11.54,0,1,1,0,23.081",
    transform: "translate(-17206.285 6514.985)",
    fill: "#ff8500"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22",
    "data-name": "Path 22",
    d: "M559.928,654.636a11.541,11.541,0,1,0,.123,23.081,11.678,11.678,0,0,0,7.755-2.992,11.04,11.04,0,0,0,1.159-1.221h-2.381a14.158,14.158,0,0,1-.854-1.16h4.087a7.8,7.8,0,0,0,.672-1.221h-5.431a7.24,7.24,0,0,1-.488-1.222h6.351a12.146,12.146,0,0,0,.61-3.662,15.727,15.727,0,0,0-.244-2.443H564.2a8.951,8.951,0,0,1,.306-1.221h6.35a7.218,7.218,0,0,0-.489-1.221H565a11.911,11.911,0,0,1,.672-1.222h4.09a5.837,5.837,0,0,0-.916-1.221h-2.259a10.486,10.486,0,0,1,1.16-1.16,11.265,11.265,0,0,0-7.754-2.992C559.989,654.636,559.989,654.636,559.928,654.636Z",
    transform: "translate(-17202.07 6514.985)",
    fill: "#ff5050"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23",
    "data-name": "Path 23",
    d: "M548.508,666.2a11.531,11.531,0,0,0,11.54,11.54,11.677,11.677,0,0,0,7.755-2.992,11.043,11.043,0,0,0,1.16-1.221h-2.381a13.981,13.981,0,0,1-.855-1.16h4.087a7.785,7.785,0,0,0,.672-1.221h-5.431a7.305,7.305,0,0,1-.489-1.222h6.351a12.117,12.117,0,0,0,.61-3.662,15.646,15.646,0,0,0-.244-2.443H564.2a8.809,8.809,0,0,1,.305-1.221h6.35a7.24,7.24,0,0,0-.489-1.222h-5.375a12.24,12.24,0,0,1,.672-1.221h4.091a5.788,5.788,0,0,0-.916-1.221h-2.259a10.493,10.493,0,0,1,1.16-1.16,11.265,11.265,0,0,0-7.754-2.992h-.06",
    transform: "translate(-17202.07 6514.965)",
    fill: "#e52836"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24",
    "data-name": "Path 24",
    d: "M561.836,677.737a11.677,11.677,0,0,0,7.755-2.992,11.054,11.054,0,0,0,1.16-1.221h-2.379a13.93,13.93,0,0,1-.855-1.16h4.09a7.8,7.8,0,0,0,.672-1.221h-5.434a7.4,7.4,0,0,1-.489-1.222h6.351a12.12,12.12,0,0,0,.61-3.662,15.637,15.637,0,0,0-.244-2.443h-7.082a8.793,8.793,0,0,1,.305-1.221h6.351a7.31,7.31,0,0,0-.489-1.222h-5.373a12.252,12.252,0,0,1,.672-1.221h4.091a5.786,5.786,0,0,0-.916-1.221h-2.26a10.424,10.424,0,0,1,1.16-1.16,11.269,11.269,0,0,0-7.755-2.992h-.064",
    transform: "translate(-17203.855 6514.965)",
    fill: "#cb2026"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_25",
    "data-name": "Path 25",
    d: "M566.308,670.532l.182-1.038a2.617,2.617,0,0,1-.3.061c-.428,0-.488-.244-.428-.367l.367-2.136h.672l.182-1.16h-.61l.122-.732h-1.221s-.732,4.029-.732,4.519a.915.915,0,0,0,.976,1.038,1.885,1.885,0,0,0,.795-.185Z",
    transform: "translate(-17204.236 6513.56)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_26",
    "data-name": "Path 26",
    d: "M567.079,668.682a1.944,1.944,0,0,0,2.137,2.137,3.174,3.174,0,0,0,1.282-.183l.244-1.16a3.673,3.673,0,0,1-1.282.306c-1.344,0-1.1-.978-1.1-.978h2.5a8.012,8.012,0,0,0,.183-1.1,1.655,1.655,0,0,0-1.772-1.772C567.995,665.812,567.079,667.155,567.079,668.682Zm2.137-1.771c.672,0,.549.794.549.854h-1.343C568.422,667.705,568.544,666.911,569.216,666.911Z",
    transform: "translate(-17204.582 6513.457)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27",
    "data-name": "Path 27",
    d: "M578,670.446l.244-1.344a2.992,2.992,0,0,1-1.038.306,1.236,1.236,0,0,1-1.221-1.4c0-1.466.732-2.259,1.587-2.259a2.049,2.049,0,0,1,1.1.367l.182-1.282a4.274,4.274,0,0,0-1.4-.306c-1.4,0-2.808,1.221-2.808,3.542,0,1.527.732,2.565,2.2,2.565A5.443,5.443,0,0,0,578,670.446Z",
    transform: "translate(-17205.605 6513.646)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28",
    "data-name": "Path 28",
    d: "M558.456,665.793a4.317,4.317,0,0,0-1.466.244l-.182,1.037a3.623,3.623,0,0,1,1.343-.244c.428,0,.795.061.795.428,0,.244-.061.3-.061.3h-.549c-1.038,0-2.2.428-2.2,1.831,0,1.1.732,1.344,1.16,1.344a1.829,1.829,0,0,0,1.282-.55l-.061.488h1.1l.489-3.358a1.443,1.443,0,0,0-1.65-1.525Zm.244,2.746c0,.183-.123,1.16-.855,1.16a.47.47,0,0,1-.189-.034.475.475,0,0,1-.3-.455c0-.3.183-.732,1.1-.732a.944.944,0,0,0,.244.061Z",
    transform: "translate(-17203.102 6513.476)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29",
    "data-name": "Path 29",
    d: "M561.847,670.731a1.567,1.567,0,0,0,1.832-1.588c0-1.526-1.466-1.221-1.466-1.831,0-.3.244-.428.672-.428.182,0,.854.061.854.061l.183-1.1a4.639,4.639,0,0,0-1.16-.122c-.916,0-1.831.366-1.831,1.587,0,1.4,1.527,1.283,1.527,1.831,0,.367-.428.428-.732.428a3.991,3.991,0,0,1-1.1-.183l-.183,1.1C560.5,670.608,560.809,670.731,561.847,670.731Z",
    transform: "translate(-17203.684 6513.484)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_30",
    "data-name": "Path 30",
    d: "M589.7,664.665l-.244,1.649a1.686,1.686,0,0,0-1.16-.611c-1.1,0-2.075,1.344-2.075,2.93,0,.978.489,2.016,1.526,2.016a1.631,1.631,0,0,0,1.16-.489l-.06.428h1.221l.916-5.862Zm-.549,3.236c0,.672-.3,1.527-.977,1.527-.428,0-.672-.367-.672-.977,0-.977.428-1.588.977-1.588.427,0,.671.3.671,1.038Z",
    transform: "translate(-17207.174 6513.627)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31",
    "data-name": "Path 31",
    d: "M550.939,670.526l.732-4.4.123,4.4h.854l1.587-4.4-.672,4.4h1.283l.977-5.861h-2.015l-1.221,3.6-.062-3.6h-1.77l-.977,5.861Z",
    transform: "translate(-17202.242 6513.627)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32",
    "data-name": "Path 32",
    d: "M572.8,670.7c.366-2.015.427-3.662,1.282-3.358a4.772,4.772,0,0,1,.428-1.4h-.244c-.55,0-.977.732-.977.732l.122-.671h-1.16l-.795,4.766H572.8Z",
    transform: "translate(-17205.176 6513.455)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33",
    "data-name": "Path 33",
    d: "M581.408,665.792a4.313,4.313,0,0,0-1.466.244l-.183,1.038a3.622,3.622,0,0,1,1.343-.244c.428,0,.795.061.795.428,0,.244-.061.3-.061.3h-.549c-1.038,0-2.2.428-2.2,1.831,0,1.1.732,1.344,1.16,1.344a1.829,1.829,0,0,0,1.282-.55l-.06.488h1.1l.489-3.358a1.426,1.426,0,0,0-1.652-1.527Zm.3,2.746c0,.183-.123,1.16-.855,1.16a.469.469,0,0,1-.188-.034.48.48,0,0,1-.3-.455c0-.3.183-.732,1.1-.732.182.061.182.061.243.061Z",
    transform: "translate(-17206.209 6513.477)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34",
    "data-name": "Path 34",
    d: "M584.667,670.7c.366-2.015.428-3.662,1.282-3.358a4.818,4.818,0,0,1,.428-1.4h-.245c-.549,0-.977.732-.977.732l.122-.671h-1.159l-.795,4.766h1.344Z",
    transform: "translate(-17206.783 6513.455)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35",
    "data-name": "Path 35",
    d: "M564.4,669.678a.915.915,0,0,0,.977,1.037,2.314,2.314,0,0,0,.916-.183l.182-1.038a2.618,2.618,0,0,1-.3.061c-.428,0-.489-.244-.428-.367l.367-2.136h.672l.182-1.16h-.61l.122-.732",
    transform: "translate(-17204.219 6513.56)",
    fill: "#dce5e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36",
    "data-name": "Path 36",
    d: "M567.787,668.682c0,1.709.549,2.137,1.527,2.137a3.178,3.178,0,0,0,1.282-.183l.244-1.16a3.676,3.676,0,0,1-1.282.306c-1.344,0-1.1-.978-1.1-.978h2.5a7.747,7.747,0,0,0,.183-1.1,1.655,1.655,0,0,0-1.771-1.772C568.092,665.812,567.787,667.155,567.787,668.682Zm1.527-1.771c.671,0,.794.794.794.854H568.52c0-.06.123-.854.795-.854Z",
    transform: "translate(-17204.678 6513.457)",
    fill: "#dce5e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37",
    "data-name": "Path 37",
    d: "M578.09,670.446l.244-1.344a2.987,2.987,0,0,1-1.038.306,1.235,1.235,0,0,1-1.221-1.4c0-1.466.732-2.259,1.587-2.259a2.049,2.049,0,0,1,1.1.367l.183-1.282a4.284,4.284,0,0,0-1.4-.306c-1.4,0-2.2,1.221-2.2,3.542,0,1.527.122,2.565,1.587,2.565A5.426,5.426,0,0,0,578.09,670.446Z",
    transform: "translate(-17205.701 6513.646)",
    fill: "#dce5e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38",
    "data-name": "Path 38",
    d: "M556.807,667.157a3.62,3.62,0,0,1,1.343-.245c.428,0,.795.062.795.428,0,.244-.061.306-.061.306h-.549c-1.038,0-2.2.427-2.2,1.831,0,1.1.732,1.343,1.16,1.343a1.831,1.831,0,0,0,1.282-.549l-.061.488h1.1l.489-3.358c0-1.4-1.221-1.466-1.709-1.466Zm2.5,1.4a2,2,0,0,1-1.466,1.16.476.476,0,0,1-.489-.488c0-.3.183-.732,1.1-.732a4.952,4.952,0,0,0,.853.06Z",
    transform: "translate(-17203.102 6513.455)",
    fill: "#dce5e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39",
    "data-name": "Path 39",
    d: "M560.514,670.608a5.175,5.175,0,0,0,1.4.123,1.565,1.565,0,0,0,1.831-1.588c0-1.526-1.466-1.221-1.466-1.831,0-.3.244-.428.672-.428.183,0,.855.061.855.061l.182-1.1a4.625,4.625,0,0,0-1.16-.122c-.915,0-1.221.366-1.221,1.587,0,1.4.916,1.283.916,1.831,0,.367-.428.428-.732.428",
    transform: "translate(-17203.693 6513.484)",
    fill: "#dce5e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40",
    "data-name": "Path 40",
    d: "M589.548,666.322a1.692,1.692,0,0,0-1.16-.611c-1.1,0-1.466,1.344-1.466,2.93,0,.978-.122,2.016.916,2.016a1.632,1.632,0,0,0,1.16-.489l-.06.428h1.221l.916-5.862Zm-.061,1.587c0,.672-.549,1.527-1.221,1.527-.428,0-.672-.367-.672-.977,0-.977.428-1.588.977-1.588a.93.93,0,0,1,.69.315.933.933,0,0,1,.228.724Z",
    transform: "translate(-17207.268 6513.618)",
    fill: "#dce5e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41",
    "data-name": "Path 41",
    d: "M550.939,670.526l.732-4.4.123,4.4h.854l1.587-4.4-.672,4.4h1.283l.977-5.861H554.3l-1.709,3.6-.062-3.6h-.672l-2.075,5.861Z",
    transform: "translate(-17202.242 6513.627)",
    fill: "#dce5e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42",
    "data-name": "Path 42",
    d: "M571.53,670.7h1.283c.366-2.015.427-3.662,1.282-3.358a4.8,4.8,0,0,1,.428-1.4h-.246c-.549,0-.977.732-.977.732l.122-.671",
    transform: "translate(-17205.186 6513.455)",
    fill: "#dce5e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_43",
    "data-name": "Path 43",
    d: "M579.759,667.157a3.62,3.62,0,0,1,1.343-.245c.428,0,.795.062.795.428,0,.244-.061.306-.061.306h-.549c-1.038,0-2.2.427-2.2,1.831,0,1.1.732,1.343,1.16,1.343a1.832,1.832,0,0,0,1.282-.549l-.06.488h1.1l.489-3.358c0-1.4-1.221-1.466-1.709-1.466Zm2.5,1.4a2,2,0,0,1-1.466,1.16.469.469,0,0,1-.188-.034.478.478,0,0,1-.161-.105.5.5,0,0,1-.105-.16.475.475,0,0,1-.034-.189c0-.305.183-.732,1.1-.732a5.3,5.3,0,0,0,.853.06Z",
    transform: "translate(-17206.209 6513.455)",
    fill: "#dce5e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44",
    "data-name": "Path 44",
    d: "M583.4,670.7h1.282c.366-2.015.428-3.662,1.282-3.358a4.821,4.821,0,0,1,.428-1.4h-.247c-.549,0-.977.732-.977.732l.122-.671",
    transform: "translate(-17206.791 6513.455)",
    fill: "#dce5e5"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcAddPropertyPaymentMaster);
export default __webpack_public_path__ + "static/media/ic_add_property_payment_master.404b76fc745a6f0fcc0f2794d69b887b.svg";
export { ForwardRef as ReactComponent };